'use strict';

const BasePresenter = require('./base');

class PickerPresenter extends BasePresenter {
  selected() {
    return this.model.get(this.options.selectionName);
  }

  isSelectable() {
    return this.collection.length > 1;
  }

  toHash() {
    return {
      icon: this.options.icon,
      expanded: this.options.expanded,
      selectable: this.isSelectable() || !this.selected(),
    };
  }
}

module.exports = PickerPresenter;
